import CTA13_morph_right from './CTA13_morph_right'
export default CTA13_morph_right
